import { Word } from '../../../../model/Word';
import DefinitionItem from '../Items/DefinitionItem/DefinitionItem';
import styles from './GivenWordPickDefinition.module.scss';

interface GivenWordPickDefinitionProps {
    shuffledChoices: { isCorrect: boolean, text: string, wordId: number }[];
    onAnswer: (isCorrect: boolean) => void;
    correctWord: Word;
    handlePlayAudio: (checkAutoPronounce: boolean) => void;
    isPlaying: boolean;
}

const GivenWordPickDefinition = ({ shuffledChoices, onAnswer, correctWord, handlePlayAudio, isPlaying }: GivenWordPickDefinitionProps) => {
    return (
        <div className={styles.givenWordPickDefinition}>
            <h1 className={`${styles.wordInfo} ${isPlaying ? styles.playing : ''}`}
                onClick={() => handlePlayAudio(false)}>{correctWord?.Text}</h1>
            <div className={styles.definitionContainer}>
                {shuffledChoices.map((choice, index) => (
                    <DefinitionItem
                        key={index}
                        choice={choice}
                        index={index}
                        onAnswer={onAnswer}
                        correctWord={correctWord}
                    />
                ))}
            </div>
        </div>
    );
};

export default GivenWordPickDefinition;